module.exports = __webpack_public_path__ + "assets/img/42cc4a327269415422487caaa344c4d4.svg";